import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './context/ProtectedRoute';

import DashboardLayout from './components/DashboardLayout';

// ── Public / marketing pages ─────────────────────────────────────────
import LandingPage   from './pages/LandingPage';
import Login         from './pages/Login';
import Register      from './pages/Register';
import Pricing       from './pages/Pricing';
import Docs          from './pages/Docs';
import Status        from './pages/Status';

// ── Company pages ────────────────────────────────────────────────────
import About         from './pages/About';
import Blog          from './pages/Blog';
import Careers       from './pages/Careers';
import Contact       from './pages/Contact';

// ── Legal pages ──────────────────────────────────────────────────────
import PrivacyPolicy   from './pages/PrivacyPolicy';
import TermsOfService  from './pages/TermsOfService';
import SecurityPage    from './pages/SecurityPage';
import CookiePolicy    from './pages/CookiePolicy';

// ── Dashboard pages ──────────────────────────────────────────────────
import Dashboard         from './pages/Dashboard';
import WalletScannerPage from './pages/WalletScannerPage';
import ScanHistory       from './pages/ScanHistory';
import SavedReports      from './pages/SavedReports';
import ApiAccess         from './pages/ApiAccess';
import Billing           from './pages/Billing';
import SettingsPage      from './pages/SettingsPage';

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

function App() {
  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* ── Public ────────────────────────────────────────────── */}
            <Route path="/"        element={<LandingPage />} />
            <Route path="/login"   element={<Login />} />
            <Route path="/register"element={<Register />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/docs"    element={<Docs />} />
            <Route path="/status"  element={<Status />} />

            {/* ── Company ───────────────────────────────────────────── */}
            <Route path="/about"   element={<About />} />
            <Route path="/blog"    element={<Blog />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/contact" element={<Contact />} />

            {/* ── Legal ─────────────────────────────────────────────── */}
            <Route path="/privacy"  element={<PrivacyPolicy />} />
            <Route path="/terms"    element={<TermsOfService />} />
            <Route path="/security" element={<SecurityPage />} />
            <Route path="/cookies"  element={<CookiePolicy />} />

            {/* ── Protected dashboard (nested) ──────────────────────── */}
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <DashboardLayout />
                </ProtectedRoute>
              }
            >
              <Route index           element={<Dashboard />} />
              <Route path="scanner"  element={<WalletScannerPage />} />
              <Route path="history"  element={<ScanHistory />} />
              <Route path="reports"  element={<SavedReports />} />
              <Route path="api"      element={<ApiAccess />} />
              <Route path="billing"  element={<Billing />} />
              <Route path="settings" element={<SettingsPage />} />
            </Route>

            {/* ── Catch-all ─────────────────────────────────────────── */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </GoogleOAuthProvider>
  );
}

export default App;
